import React from 'react';

export const LoaderSkeleton = () => {
  return (
    <div className="flex w-full animate-pulse items-center space-x-4 py-4">
      <div className="h-4 w-[40%] rounded bg-gray-200"></div>
      <div className="h-4 w-[15%] rounded bg-gray-200"></div>
      <div className="h-4 w-[10%] rounded bg-gray-200"></div>
      <div className="h-4 w-[20%] rounded bg-gray-200"></div>
      <div className="h-4 w-[15%] rounded bg-gray-200"></div>
    </div>
  );
};
